var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import NumberInput from '@declaration/components/NumberInput.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { ANTENNA_COUNT_LABEL, ANTENNA_TITLE, } from '@declaration/constants/externalDamages/AntennaConstants';
let Antenna = class Antenna extends ExternalDamageComponent {
    get title() {
        return this.translateExternalDamageKey(ANTENNA_TITLE);
    }
    get antennaCountLabel() {
        return this.translateExternalDamageKey(ANTENNA_COUNT_LABEL);
    }
    get antennaCount() {
        var _a;
        return (_a = this.externalDamage.antennaCount) !== null && _a !== void 0 ? _a : 0;
    }
    set antennaCount(antennaCount) {
        this.updateExternalDamage({ antennaCount });
    }
};
Antenna = __decorate([
    Component({
        components: {
            RadioPrimaryButton,
            NumberInput,
        },
    })
], Antenna);
export default Antenna;
